import React from "react";
import Banner from "./Cards/Banner";
import { useNavigate } from "react-router-dom";
import { convertToKebabCase } from "src/helpers/helperFunctions";

const BannerSections = ({
  images,
  className,
  style,
  bannerClassName,
  bannerStyle,
  blackOverlay,
  isLoading,
  id = "",
  onClick,
  loadingClassName,
}: {
  images: {
    image: string;
    name: string;
    _id: string;
  }[];
  className?: string;
  style?: React.CSSProperties;
  bannerClassName?: string;
  bannerStyle?: React.CSSProperties;
  blackOverlay?: boolean;
  isLoading?: boolean;
  id?: string;
  onClick?: (data: { image: string; name: string; _id: string }) => void;
  loadingClassName?: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="view-area-width mx-auto py-3">
      <div
        className={`w-full overflow-hidden grid grid-cols-1 gap-5 ${
          images.length > 1 ? "md:grid-cols-2" : ""
        } ${className}`}
        style={{ ...style }}
      >
        {images.map((image, index) => (
          <Banner
            id={id}
            key={index}
            image={image}
            isLoading={isLoading}
            className={bannerClassName}
            loadingClassName={loadingClassName} 
            style={bannerStyle}
            blackOverlay={blackOverlay}
            onClick={() => onClick?.(image)}
          />
        ))}
      </div>
    </div>
  );
};

export default BannerSections;
